import { DropdownMenu } from "radix-ui"
import { cn } from "app/lib/utils"
import { ComponentProps } from "react"
import { poppins } from "theme/fonts"
import { getVideoPlayerPortalContainer } from "../../utils/getVideoPlayerPortalContainer"
import PlayerIconButton from "./PlayerIconButton"

type Props = {
  title: React.ReactNode
  icon: React.ReactNode
  activeIcon?: React.ReactNode
  triggerToggled?: boolean
  triggerColor?: ComponentProps<typeof PlayerIconButton>["color"]
  triggerSize?: ComponentProps<typeof PlayerIconButton>["size"]
  children: React.ReactNode
  className?: string
  menuWidth?: keyof typeof menuWidthClass
} & Omit<ComponentProps<typeof DropdownMenu.Root>, "children">

const menuWidthClass = {
  210: "w-[210px]",
  260: "w-[260px]",
  270: "w-[270px]",
  280: "w-[280px]",
} as const

export default function PlayerOptionModal({
  title,
  icon,
  activeIcon,
  triggerToggled = false,
  triggerColor,
  triggerSize,
  children,
  open,
  className,
  menuWidth = 210,
  ...props
}: Props) {
  const isTriggerActive = !!open || triggerToggled

  return (
    <DropdownMenu.Root open={open} {...props}>
      <DropdownMenu.Trigger asChild>
        <PlayerIconButton
          color={triggerColor}
          size={triggerSize}
          toggled={isTriggerActive}
        >
          {isTriggerActive && activeIcon ? activeIcon : icon}
        </PlayerIconButton>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal container={getVideoPlayerPortalContainer()}>
        <DropdownMenu.Content
          align="end"
          side="top"
          sideOffset={4}
          className="z-50 outline-none"
          onClick={(e) => {
            e.stopPropagation()
          }}
        >
          <div
            className={cn(
              "flex flex-col items-start rounded-lg border border-black bg-neutraal-950 p-1 text-base shadow-[0_0_4px_rgba(0,0,0,0.25)]",
              menuWidthClass[menuWidth],
              poppins.className,
              className
            )}
          >
            <div className="flex w-full items-center border-b border-white/40 px-3 py-2">
              <div className="text-2xs font-medium tracking-wide text-white uppercase opacity-80">
                {title}
              </div>
            </div>
            {children}
          </div>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
